import { motion } from "framer-motion";
import { CLOSING_STATEMENT, TAGLINE } from "../config/brands";

export default function Footer() {
    return (
        <footer className="relative border-t border-amber-400/10 px-5 pt-20 pb-10" aria-label="Footer">
            <div
                className="pointer-events-none absolute inset-0"
                aria-hidden="true"
                style={{
                    background:
                        "radial-gradient(60% 60% at 50% 100%, rgba(212,175,55,0.08), transparent 70%)",
                }}
            />
            <div className="relative mx-auto max-w-6xl text-center">
                <motion.p
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                    className="font-display text-gold-gradient text-3xl leading-snug font-medium tracking-tight sm:text-4xl lg:text-5xl"
                >
                    {CLOSING_STATEMENT}
                </motion.p>

                <div className="gold-hairline mx-auto mt-14 max-w-md" aria-hidden="true" />

                <div className="mt-10 flex flex-col items-center justify-between gap-4 sm:flex-row">
                    <p className="font-mono-lux text-[10px] tracking-[0.25em] text-slate-500 uppercase">
                        © 2026 Truth Excellence Group LLC
                    </p>
                    <p className="font-mono-lux text-[10px] tracking-[0.25em] text-slate-600 uppercase">
                        {TAGLINE}
                    </p>
                </div>
            </div>
        </footer>
    );
}
